import arrow from '../assets/icons/arrow.svg';
import downArrow from '../assets/icons/downArrow.svg';
import email from '../assets/icons/email.svg';
import facebook from '../assets/icons/footer/facebook.svg';
import facebookAlt from '../assets/icons/socialAlt/facebook-alt.svg';
import googlePlus from '../assets/icons/gplus.svg';
import hamburger from '../assets/icons/hamburger.svg';
import instagram from '../assets/icons/footer/instagram.svg';
import instagramAlt from '../assets/icons/socialAlt/instagram-alt.svg';
import leftArrowSimple from '../assets/icons/left-arrow-simple.svg';
import linkedin from '../assets/icons/footer/linkedin.svg';
import linkedinAlt from '../assets/icons/socialAlt/linkedin-alt.svg';
import loadingDots from '../assets/icons/loading-dots.svg';
import loadingSpinner from '../assets/icons/loading-spinner.svg';
import pinterest from '../assets/icons/pinterest.svg';
import rightArrow from '../assets/icons/right-arrow.svg';
import rss from '../assets/icons/footer/rss.svg';
import search from '../assets/icons/search.svg';
import speechBubbles from '../assets/icons/speech-bubbles.svg';
import twitter from '../assets/icons/footer/twitter.svg';
import twitterAlt from '../assets/icons/socialAlt/twitter-alt.svg';
import x from '../assets/icons/x.svg';
import xGrey from '../assets/icons/xGrey.svg';
import xThinSpaceGrey from '../assets/icons/x-thin-space-grey.svg';
import youtube from '../assets/icons/footer/youtube.svg';
import youtubeAlt from '../assets/icons/socialAlt/youtube-alt.svg';
import whatsapp from '../assets/icons/whatsapp.svg';
import whatsappAlt from '../assets/icons/socialAlt/whatsapp-alt.svg';

export default {
  arrow,
  downArrow,
  email,
  facebook,
  facebookAlt,
  googlePlus,
  hamburger,
  instagram,
  instagramAlt,
  leftArrowSimple,
  linkedin,
  linkedinAlt,
  loadingDots,
  loadingSpinner,
  pinterest,
  rightArrow,
  rss,
  search,
  speechBubbles,
  twitter,
  twitterAlt,
  whatsapp,
  whatsappAlt,
  x,
  xGrey,
  xThinSpaceGrey,
  youtube,
  youtubeAlt,
};
